import gql from "fraql";

import { MasterRolesFragment } from "@composables/masterdata/person/roles";
import { MasterLicenceCategoryFragment } from "@composables/masterdata/person/licenceCategories";
import { MasterProfQualificationFragment } from "@composables/masterdata/person/profQualifications";
import { MasterProfQualificationGroupFragment } from "@composables/masterdata/person/profQualificationGroups";
import { MasterProfQualificationApprovalReasonFragment } from "@composables/masterdata/person/profQualificationApprovalReasons";

import { MasterQualificationGroupFragment } from "@composables/masterdata/qualifications/qualificationGroups";
import { MasterInsuranceCategoryFragment } from "@composables/masterdata/insuranceCategories";

import { MasterDisciplineFragment } from "@composables/masterdata/competitions/disciplines";
import { MasterCompetitionLevelFragment } from "@composables/masterdata/competitions/competitionLevels";
import { MasterDifficultyLevelFragment } from "@composables/masterdata/competitions/difficultyLevels";
//import { MasterDifficultyGroupFragment } from "@composables/masterdata/competitions/difficultyGroups";
import { MasterEventcodeFragment } from "@composables/masterdata/competitions/eventcodes";
import { MasterCompetitionRuleFragment } from "@composables/masterdata/competitions/competitionRules";
import { MasterSectionFragment } from "@composables/masterdata/competitions/sections";

import { MasterProductFragment } from "@composables/masterdata/products/products";
import { MasterSystemProductFragment } from "@composables/masterdata/products/systemProducts";
import { MasterEventProductCategoryFragment } from "@composables/masterdata/products/eventProductCategories";
import { MasterCancelReasonFragment } from "./composables/masterdata/cancelReasons";
import { MasterEventCategoryFragment } from "@composables/masterdata/eventCategories";
import { MasterEventInfoCategoryFragment } from "./composables/masterdata/eventInfoCategories";
import { MasterVatRateFragment } from "./composables/masterdata/vatRates";

import { FederationConfigurationFragment } from "@composables/masterdata/config";
import { MasterCountryFragment } from "@composables/masterdata/countries";
import { MasterRegionFragment } from "@composables/masterdata/regions";
import { MasterLegalFormFragment } from "@composables/masterdata/legalForms";
import { MasterExamGroupFragment } from "@composables/masterdata/examGroups";
import { MasterExamDefinitionFragment } from "@composables/masterdata/examDefinitions";
import { MasterOrganisationalFunctionFragment } from "@composables/masterdata/organisationalFunctions";
import { MasterOrganisationalTitleFragment } from "@composables/masterdata/organisationalTitles";

import { MasterCertificateDefinitionFragment } from "@composables/masterdata/certificateDefinitions";
import { MasterCertificateGroupFragment } from "@composables/masterdata/certificateGroups";

import { MasterStudbookFragment } from "@composables/masterdata/studbooks";
import { MasterHorseColorFragment } from "./composables/masterdata/horseColors";
import { MasterHorseDocumentIssuingBodyFragment } from "./composables/masterdata/horseDocumentIssuingBodies";

import { MasterBreedFragment } from "@composables/masterdata/breeds";
import { MasterCupSeasonFragment } from "./composables/masterdata/cupSeasons";
import { MasterCompetitionEntryRuleTemplateFragment } from "./composables/masterdata/competitions/competitionEntryRuleTemplates";

import { MasterCompetingDifficultyLevelGroupsFragment } from "@composables/masterdata/competing/competingDifficultyLevelGroups";
import { MasterCompetingDifficultyLevelDefinitionFragment } from "@composables/masterdata/competing/competingDifficultyLevelDefinitions";

import { MasterQualificationFragment } from "@composables/masterdata/qualifications/qualifications";

import { EventStaffFunctionDefinitionFragment } from "@composables/masterdata/eventStaffFunctions/eventStaffFunctionDefinitions";

export default gql`
  query preLoadMasterdata {
    federationConfiguration {
      ${FederationConfigurationFragment}
      frontendVersionNumber
    }

    ponyTypes

    qualifications {
      id
      ${MasterQualificationFragment}
    }

    competingDifficultyLevelGroups {
      ${MasterCompetingDifficultyLevelGroupsFragment}
    }

    competingDifficultyLevelDefinitions {
      ${MasterCompetingDifficultyLevelDefinitionFragment}
    }

    guardedRoutes {
      name
      description
      group
    }

    competitionEntryRuleTemplates {
      ${MasterCompetitionEntryRuleTemplateFragment}
    }

    insuranceCategories {
      ${MasterInsuranceCategoryFragment}
    }

    horseColors {
      ${MasterHorseColorFragment}
    }

    studbooks {
      ${MasterStudbookFragment}
    }

    certificateGroups {
      id
      ${MasterCertificateGroupFragment}
    }

    certificateDefinitions {
      id
      ${MasterCertificateDefinitionFragment}
    }

    organisationalFunctions {
      id
      ${MasterOrganisationalFunctionFragment}
    }

    organisationalTitles {
      id
      ${MasterOrganisationalTitleFragment}
    }

    examGroups {
      id
      ${MasterExamGroupFragment}
    }

    examDefinitions {
      id
      ${MasterExamDefinitionFragment}
    }

    profQualificationGroups {
      ${MasterProfQualificationGroupFragment}
    }

    profQualifications {
      ${MasterProfQualificationFragment}
    }

    profQualificationApprovalReasons {
      ${MasterProfQualificationApprovalReasonFragment}
    }

    qualificationGroups {
      ${MasterQualificationGroupFragment}
    }
    
    eventProductCategories {
      id
      ${MasterEventProductCategoryFragment}
    }

    eventCategories {
      ${MasterEventCategoryFragment}
    }

    licenceCategories {
      ${MasterLicenceCategoryFragment}
    }

    disciplines {
      ${MasterDisciplineFragment}
    }

    cancelReasons {
      ${MasterCancelReasonFragment}
    }

    competitionLevels {
      ${MasterCompetitionLevelFragment}
    }

    eventcodes {
      ${MasterEventcodeFragment}
    }

    competitionRules {
    ${MasterCompetitionRuleFragment}
    }

    difficultyLevels {
      ${MasterDifficultyLevelFragment}
    }

    sections {
      ${MasterSectionFragment}
    }

    vatRates {
      ${MasterVatRateFragment}
    }

    disciplines {
      ${MasterDisciplineFragment}
    }

    legalForms {
      ${MasterLegalFormFragment}
    }

    roles {
      ${MasterRolesFragment}
    }

    countries {
      ${MasterCountryFragment}
    }

    breeds {
      ${MasterBreedFragment}
    }

    horseDocumentIssuingBodies {
      ${MasterHorseDocumentIssuingBodyFragment}
    }

    regions {
      ${MasterRegionFragment}
    }

    eventInfoCategories {
      ${MasterEventInfoCategoryFragment}
    }

    products {
      ${MasterProductFragment}
    }

    systemProducts {
      ${MasterSystemProductFragment}
    }

    cupSeasons {
      ${MasterCupSeasonFragment}
    }

    eventStaffFunctionDefinitions {
      ${EventStaffFunctionDefinitionFragment}
    }
  }
`;
